import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { BaseErrorView } from '~/components/base-error-view/BaseErrorView';

export const InsightsGroupRoot = styled.div`
  height: 100%;
  padding-right: 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
`;

export const Title = styled.h4`
  ${typographyV2.titleBase};
`;

export const Text = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StyledBaseErrorView = styled(BaseErrorView)`
  max-height: 200px;
  border-bottom: 1px solid var(--border-soft);
`;
